import { useMutation } from "@tanstack/react-query";
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "Redux/axiosHelper";
import { AddActivitiesToSpecificTemplate, CreateScheduleTemplateBody, RemoveActivityFromTemplate } from "types/scheduleTemplate/scheduleTemplate";

//Create OR Update Schedule Template
const createScheduleTemplate = async (payload: { data: CreateScheduleTemplateBody, organizationId: string }) => {
  const response = await axiosPost(payload.data, `v1/schedule-template/create/${payload.organizationId}`);
  return response.data;
};


export const useCreateScheduleTemplate = () => {
  return useMutation({
    mutationFn: createScheduleTemplate,
  });
};


//Get Schedule Templates
const getScheduleTemplates = async (organizationId: string) => {
  const response = await axiosGet(`v1/schedule-template/${organizationId}`);
  return response.data;
};

export const useGetScheduleTemplates = () => {
  return useMutation({
    mutationFn: getScheduleTemplates,
  });
};

//Get All Active Templates
const getAllActiveTemplates = async (params?: { page?: number, limit?: number }) => {
  const response = await axiosGet(`v1/schedule-template/active-templates`, params);
  return response.data;
};

export const useGetAllActiveTemplates = () => {
  return useMutation({
    mutationFn: getAllActiveTemplates,
  });
};

//Update Specific Template
const updateSpecificTemplate = async (tempId: string) => {
  const response = await axiosPatch({}, `v1/schedule-template/${tempId}`);
  return response.data;
};

export const useUpdateSpecificTemplate = () => {
  return useMutation({
    mutationFn: updateSpecificTemplate,
  });
};


//Get schedule template by id
const getScheduleTemplateById = async (tempId: string) => {
  const response = await axiosGet(`v1/schedule-template/by-id/${tempId}`);
  return response.data;
};

export const useGetScheduleTemplateById = () => {
  return useMutation({
    mutationFn: getScheduleTemplateById,
  });
};


//Remove activity specific template
const removeActivityFromTemplate = async ({ tempId, payload}: { tempId: string, payload: RemoveActivityFromTemplate}) => {
  const response = await axiosPatch(payload, `v1/schedule-template/remove-activity/${tempId}`);
  return response.data;
};

export const useRemoveActivityFromTemplate = () => {
  return useMutation({
    mutationFn: removeActivityFromTemplate,
  });
};


//Remove specific template

const removeTemplate = async (tempId: string) => {
  const response = await axiosDelete(`v1/schedule-template/remove-template/${tempId}`);
  return response.data;
};

export const useRemoveTemplate = () => {
  return useMutation({
    mutationFn: removeTemplate,
  });
};

//Add activities in specific template

const addActivitiesToSpecificTemplate = async ({ tempId, payload }: { tempId: string, payload:  AddActivitiesToSpecificTemplate  }) => {
  const response = await axiosPatch(payload, `v1/schedule-template/add-activities/${tempId}`);
  return response.data;
};

export const useAddActivitiesToSpecificTemplate = () => {
  return useMutation({
    mutationFn: addActivitiesToSpecificTemplate,
  });
};
